import React from "react";
import { Navigate } from "react-router-dom";
import Menu from "@shared/layout/Menu";
import Profile from "@features/preferences/components/Profile";
import About from "@features/preferences/components/About";
import Sidebar from "@features/preferences/components/Sidebar";
import Version from "@features/preferences/components/Version";
import Notifications from "@features/preferences/components/Notifications";

const routes = [
  {
    path: "/preferences",
    element: (
      <>
        <Navigate to="/preferences/profile" />
        <Menu
          content={<Sidebar contentdisplay={<Profile />} title="Profile" />}
        />
      </>
    ),
    isProtected: true,
  },
  {
    path: "/preferences/profile",
    element: (
      <Menu
        content={<Sidebar contentdisplay={<Profile />} title="Profile" />}
      />
    ),
    isProtected: true,
  },
  {
    path: "/preferences/notifications",
    element: (
      <Menu
        content={
          <Sidebar contentdisplay={<Notifications />} title="Benachrichtigungen" />
        }
      />
    ),
    isProtected: true,
  },
  {
    path: "/preferences/version",
    element: (
      <Menu
        content={<Sidebar contentdisplay={<Version />} title="Version" />}
      />
    ),
    isProtected: true,
  },
  {
    path: "/preferences/about",
    element: (
      <Menu
        content={<Sidebar contentdisplay={<About />} title="Über sophyapp" />}
      />
    ),
    isProtected: true,
  },
];

export default routes;
